<div class="bottom-menu-wrapper" *ngIf="!isHideToolbar">
  <ul class=" m-0 p-0 flex-start menu-list">
    <li *ngFor="let nav of navItems" class="menu-list-item flex-column flex-center-center" [ngClass]="{'tech-top': position === 'top', 
      'tech-bottom': position === 'bottom', 'active': nav.link === link}"
      [ngStyle]="{'width': 100/navItems.length + '%'}" (click)="navigate(nav.link)">
      <i [class]="nav.icon" [ngClass]="{'menu-item-icon non-selected': true}"></i>
      <i [class]="nav.iconActive" [ngClass]="{'menu-item-icon selected': true}"></i>
      <div class="nav-label">
        <p class="m-0 text-truncate width-100p font-10">{{currentLang === 'fr'? nav.labelFR : nav.label}}</p>
        <div class="flex-center-center notificaton-badge" *ngIf="nav.hasNotification && unreadNotificationCount">
          {{unreadNotificationCount}}
        </div>
        <div class="flex-center-center notificaton-badge" *ngIf="nav.hasTsNotification && tsCount">
          {{tsCount}}
        </div>
      </div>
    </li>
  </ul>
</div>